@if (description.length > 0){
<p
	[ngClass]="class"
	class="text-surface-800 font-normal dark:text-surface-400 text-base/6"
	[innerHTML]="description"></p>
}
